module.exports = __webpack_public_path__ + "fa2772327f55d8198301fdb8bcfc8158.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.3.3.7@bootstrap/dist/fonts/glyphicons-halflings-regular.woff
 ** module id = 180
 ** module chunks = 0
 **/